import { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { useTranslation } from 'react-i18next'
import PageModal from '../../common/PageModal'
import SimpleButton from '../../common/SimpleButton'
import Dropdown from '../../common/Dropdown'
import LoadingSpinner from '../../common/LoadingSpinner'
import { ExpandLessIcon, ExpandMoreIcon } from '../../../icons'
import { getProductModels } from '../../../utils/requests/productModelsAPI'
import '../uploads.scss'

const ViewProductType = (props) => {
  const { t } = useTranslation()
  const { typeDetails, handleEditType, closeModal } = props
  const [areModelsExpanded, setAreModelsExpanded] = useState(true)
  const [relatedModels, setRelatedModels] = useState([])
  const [isLoadingModels, setIsLoadingModels] = useState(false)
  const [hasLoadedModels, setHasLoadedModels] = useState(false)

  useEffect(() => {
    if (areModelsExpanded && !hasLoadedModels && typeDetails?.id) {
      setIsLoadingModels(true)
      getProductModels({ productTypeId: typeDetails.id })
        .then((res) => {
          setRelatedModels(res?.data?.items || res?.data || [])
          setHasLoadedModels(true)
        })
        .catch(() => {
          setRelatedModels([])
        })
        .finally(() => {
          setIsLoadingModels(false)
        })
    }
  }, [areModelsExpanded, hasLoadedModels, typeDetails?.id])

  const boolFromAnything = (v) => {
    if (typeof v === 'boolean') return v
    if (typeof v === 'string') return ['true', '1', 'y', 'yes'].includes(v.toLowerCase())
    if (typeof v === 'number') return v === 1
    return false
  }

  const headerContent = () => {
    const isActive = boolFromAnything(typeDetails?.isActive)
    const statusKey = isActive ? 'active' : 'inactive'
    return (
      <div className="status-wrapper">
        <div className="label">{t('status')}</div>
        <Dropdown
          options={[
            { key: 'active', value: t('active') },
            { key: 'inactive', value: t('inactive') },
          ]}
          className="dropdown-input"
          isDisabled={true}
          initialSelectedKey={statusKey}
        />
      </div>
    )
  }

  return (
    <>
      <PageModal
        toggle
        onToggle={closeModal}
        className="uploads-modal product-types-modal view-modal"
        title={t('details')}
        headerContent={headerContent()}
        footerContent={
          <>
            <SimpleButton className="cancel-button" onClick={closeModal}>
              {t('close')}
            </SimpleButton>
            <SimpleButton className="action-button" onClick={handleEditType}>
              {t('edit')}
            </SimpleButton>
          </>
        }
      >
        <div className="uploads-modal-content">
          <div className="section-title">{t('general_information').toUpperCase()}</div>
          <div className="row-wrapper">
            <div className="input-wrapper">
              <p className="input-option">{t('product_type')}</p>
              <div className="value">{typeDetails?.productType || '-'}</div>
            </div>
            <div className="input-wrapper">
              <p className="input-option">{t('category')}</p>
              <div className="value">{typeDetails?.category?.name || '-'}</div>
            </div>
          </div>
          <div className="row-wrapper">
            <div className="input-wrapper">
              <p className="input-option">{t('product_models_context.device_function')}</p>
              <div className="value">{typeDetails?.deviceFunction?.name || '-'}</div>
            </div>
            <div className="input-wrapper">
              <p className="input-option">{t('dealer-portal.brand')}</p>
              <div className="value">{typeDetails?.brand?.name || '-'}</div>
            </div>
          </div>

          <div className="separator" />
          <div className="units-header" onClick={() => setAreModelsExpanded((prev) => !prev)}>
            <div className="header-title">
              <div className="title">{t('product_models_context.related_models') || 'Related Models'}</div>
              <div className="subtitle">{hasLoadedModels && <span className="highlight">{relatedModels.length}</span>}</div>
            </div>
            <div className="expand-button">{areModelsExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}</div>
          </div>
          {areModelsExpanded && (
            <>
              {isLoadingModels && (
                <div className="expandable-loading-wrapper">
                  <LoadingSpinner />
                </div>
              )}
              {!isLoadingModels && relatedModels.length === 0 && hasLoadedModels && (
                <div className="expandable-empty-state">
                  <p>{t('product_models_context.no_models_found')}</p>
                </div>
              )}
              {!isLoadingModels &&
                relatedModels.map((model, index) => (
                  <div
                    className={'item-wrapper' + (index === 0 ? ' first-item-wrapper' : '') + (index === relatedModels.length - 1 ? ' last-item-wrapper' : '')}
                    key={model.id || index}
                  >
                    <div className="item-title-wrapper">
                      <p className="title">{model.name?.toUpperCase() || '-'}</p>
                      <p className="subtitle">{model.category?.name || '-'}</p>
                    </div>
                    <div className="item-status-wrapper">
                      <p className={model.isActive ? 'is-registered' : 'not-registered'}>{model.isActive ? t('active') : t('inactive')}</p>
                    </div>
                  </div>
                ))}
            </>
          )}
        </div>
      </PageModal>
    </>
  )
}

function dispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(dispatch),
  }
}

export default connect(dispatchToProps)(ViewProductType)

